export default "__VITE_ASSET__BM9c_NBq__"